import create from 'zustand';



interface ILayout {
    displayNavMobile: boolean,
    setDisplayNavMobile: (bol: boolean) => void,
    currentUserFields: any,
    setCurrentUserFields: (obj: any) => void,
    userId:string ,
    setUserId:(str:string)=>void ,
    // برای اینک نوع جدول صفحه داشبورد تغییر دهد
    dashboardChartType:string ,
    setDashboardChartType:(str:string)=>void ,
    // برای اینک زمان دیتای جدول داشبورد تغییر دهد
    dashboardChartPeriod:string ,
    setDashboardChartPeriod:(str:string)=>void ,
}

// zustand state

export const LayoutStore = create<ILayout>((set) => ({
    displayNavMobile: false,
    setDisplayNavMobile: (data: boolean) => set((state: any) => ({ displayNavMobile: data })),

    currentUserFields: [],
    setCurrentUserFields: (data: any) => set((state: any) => ({ currentUserFields: data })),

    userId:"10",
    setUserId: (data: string) => set((state: any) => ({ userId: data })),

    dashboardChartType:"line",
    setDashboardChartType: (data: string) => set((state: any) => ({ dashboardChartType: data })),
    
    dashboardChartPeriod:"all_days",
    setDashboardChartPeriod: (data: string) => set((state: any) => ({ dashboardChartPeriod: data })),
}))